import React, { Children, isValidElement, useContext } from 'react';
import classNames from 'classnames';
import isNil from 'lodash/isNil';
import isFunction from 'lodash/isFunction';
import omit from 'lodash/omit';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import isFragment from '../_util/isFragment';
import { ShowHelp } from '../field/enum';
const ItemGroup = props => {
    const { className, children, compact, ...otherProps } = props;
    const { getProPrefixCls } = useContext(ConfigContext);
    const prefixCls = getProPrefixCls('form-item-group');
    const cls = classNames(className, prefixCls, {
        [`${prefixCls}-compact`]: compact,
    });
    const mapChildren = (child) => {
        if (!isValidElement(child)) {
            return undefined;
        }
        if (isFragment(child) && child.props) {
            return Children.map(child.props.children, innerChild => mapChildren(innerChild));
        }
        let itemStyle = {};
        if (child.props && child.props.style && (child.props.style.originalWidth || child.props.style.width)) {
            if (child.props.style.width !== '100%') {
                itemStyle = {
                    width: child.props.style.width,
                };
                child.props.style.originalWidth = child.props.style.width;
            }
            else {
                itemStyle = {
                    width: child.props.style.originalWidth || child.props.style.width,
                };
            }
            child.props.style.width = '100%';
        }
        if ((isFunction(child.type) || typeof child.type === 'object') && child.type.__PRO_FORM_ITEM) {
            return mapChildren(child.props.children);
        }
        let childCls = '';
        if (compact) {
            const { suffixCls } = child.props;
            const prefixCls = getProPrefixCls(suffixCls);
            childCls = `${prefixCls}-compact`;
        }
        return (React.createElement("span", { className: `${prefixCls}-item ${childCls}`, style: { ...itemStyle } }, child));
    };
    const childes = Children.map(children, child => mapChildren(child));
    if (isNil(childes)) {
        return null;
    }
    const passProps = omit(otherProps, [
        'label',
        'labelWidth',
        'labelTooltip',
        'help',
        'showHelp',
        'required',
        'useColon',
        'requiredMarkAlign',
        'colSpan',
        'rowSpan',
        'newLine',
    ]);
    return (React.createElement("span", Object.assign({ className: cls }, passProps), childes));
};
ItemGroup.displayName = 'ItemGroup';
ItemGroup.defaultProps = {
    showHelp: ShowHelp.label,
};
export default ItemGroup;
